export const HOTKEY_MODAL_SHOWN = "hotkey-modal-shown";
export const SIGNIN_PATH = "signin-path";
